<template>
  <div
    class="
      is-align-items-center
      is-flex
      is-flex-direction-column
      is-justify-content-center
    "
  >
    <component :is="stepComponent" @next="stepAction" />
  </div>
</template>

<script>
import RegisterForm from './RegisterForm';

export default RegisterForm;
</script>

<style lang="scss" scoped>
@import 'RegisterForm';
</style>
